import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const GET_ITEM_QUERY = print(gql`
  query EventClassification($id: Int!) {
    EventClassification(id: $id) {
      title
      id
    }
  }
`);

export interface GetItemGql {
  EventClassification: {
    id: number;
    title: string;
  };
}
